<template v-once>
  <img src="@/assets/icons/ubc_icon.png" alt="UBC icon">
</template>

<script>
export default {
  name: "Ubc",
};
</script>

<style scoped>
</style>